import { fetchConfigurationByDevice, FetchConfigurationByDeviceArgs } from '../../services';

import { processDeviceConfiguration } from './processing';
import { DeviceConfigurationResponse } from './types';

export type FetchDeviceConfigurationArgs = Required<FetchConfigurationByDeviceArgs> & {
  endpoint: string;
};

export async function fetchDeviceConfiguration(args: FetchDeviceConfigurationArgs) {
  const response = await fetchConfigurationByDevice<DeviceConfigurationResponse>(args);

  return {
    response,
    configuration: processDeviceConfiguration(response),
  };
}
